import { importPageParamsSchemaValidator } from "@grafit/shared/utils/sidebar-url-params-schema";
import { createFileRoute } from "@tanstack/react-router";
import { BidLinkPage } from "../../../pages/bid-link-page/bid-link-page";

export const Route = createFileRoute("/_auth/_project/import_/$projectId/$subProjectId/link")({
  component: BidLinkPage,
  validateSearch: importPageParamsSchemaValidator,
});
